import { IPerson, emptyPerson } from './person';

/**
 * Login
 */
export interface ILogin {
  person: IPerson;
  token: string
}

export const emptyLogin: ILogin = {
  person: {...emptyPerson},
  token: ''
};




// WEBPACK FOOTER //
// ./src/app/model/login.ts